import { Injectable } from '@angular/core';
import { CoreParameterModel } from '@fi-shared/models';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { DataFieldGroupModel } from './data-field-group-model';
import { ContentLanguagesService } from '@fi-app/utilities/fi-services/content-languages.service';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { DataFieldModel } from '@fi-app/data-field/data-field.model';
import { AppTextService } from '@fi-shared/app-text';

@Injectable()
export class DataFieldService {
    constructor(
        private fiBackend: FiBackendService,
        private appTextService: AppTextService,
        private contentLanguagesService: ContentLanguagesService,
    ) {}

    getDataFieldGroups(parameter: CoreParameterModel) {
        return this.fiBackend.fetchDataPost<DataFieldGroupModel[]>('Core/DataField/GetDataFieldGroups', parameter);
    }

    getDataFieldGroupCount(parameter: CoreParameterModel) {
        return this.fiBackend.fetchDataPost<number>('Core/DataField/GetDataFieldGroupCount', parameter);
    }

    getDataFieldGroup(objectType: number): Promise<DataFieldGroupModel> {
        return new Promise<DataFieldGroupModel>((resolve, reject) => {
            this.fiBackend
                .fetchDataPost<DataFieldGroupModel>(`Core/DataField/GetDataFieldGroup?objectType=${objectType}`)
                .then((data) => {
                    resolve(new DataFieldGroupModel(this.contentLanguagesService, data));
                }, reject);
        });
    }

    getDataFieldGroupObjectTypeById(id: number) {
        return this.fiBackend.fetchData<ObjectTypes>('Core/DataField/GetDataFieldGroupObjectTypeById/' + id);
    }

    saveDataFieldGroup(dataFieldGroup: DataFieldGroupModel) {
        return this.fiBackend.fetchDataPost<void>('Core/DataField/SaveDataFieldGroup', dataFieldGroup);
    }

    getUnitFields(unitId: number) {
        return this.getItemFields(unitId, ObjectTypes.BusinessUnit);
    }

    getUserFields(userId: number) {
        return this.getItemFields(userId, ObjectTypes.User);
    }

    private getItemFields(objectId, objectType) {
        return this.fiBackend.fetchData<DataFieldModel[]>(
            `Core/DataField/GetItemFields/${objectId || 0}/${objectType}`,
        );
    }

    getDataFieldGroupName(objectType: ObjectTypes) {
        if (objectType === ObjectTypes.BusinessUnit) return this.appTextService.get('data_field.name_units');

        if (objectType === ObjectTypes.User) return this.appTextService.get('data_field.name_users');
    }
    getDataFieldGroupDescription(objectType: ObjectTypes) {
        if (objectType === ObjectTypes.BusinessUnit) return this.appTextService.get('data_field.description_units');

        if (objectType === ObjectTypes.User) return this.appTextService.get('data_field.description_users');
    }
}
